import ContactUsButton from 'Components/ContactUsButton/ContactUsButton'
import { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { postWebService } from 'CustomHooks/postWebService';
import ValidationService from 'Services/ValidationServices'

const Popup = () => {
    const [open, setOpen] = useState(false);
    const [name, setName] = useState({name: '', edited: false});
    const [email, setEmail] = useState({email: '', edited: false});
    const [subject, setSubject] = useState({subject: '', edited: false});
    const [comment, setComment] = useState({comment: '', edited: false});
    const [emailError, setEmailError] = useState('');
    const [buttonDissable, setButtonDissable] = useState(false);
  
    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setEmailError(ValidationService.validateEmail(email.email) ? "" : "Invalid Email")
      if (ValidationService.validateEmail(email.email)) {
        postWebService(name.name, email.email, subject.subject, comment.comment).then((value) => {
          if (value) {
            setOpen(false)
          }
        })
      }
    };

    const clearClose = () => {
      setOpen(false);
      setName({name: '', edited: false});
      setEmail({email: '', edited: false});
      setSubject({subject: '', edited: false});
      setComment({comment: '', edited: false});
      setEmailError('');
    };

    useEffect(() => {
      if (name.name === "" || email.email === "" || subject.subject === "" || comment.comment === "") 
      {
        setButtonDissable(true)
      } else { 
        setButtonDissable(false)
      }
    }, [comment.comment, email.email, name.name, subject.subject]);
    
    return (
      <div>
        <ContactUsButton onClick={handleClickOpen}>
          Open form dialog
        </ContactUsButton>
        <Dialog PaperProps={{style: { borderRadius: 25 }}} className="formPopup" fullWidth maxWidth="sm" open={open} onClose={() => clearClose()} aria-labelledby="form-dialog-title">
          <DialogContent className="formPopup">
            <div className="fieldBox1">
                <TextField
                autoFocus
                error={name.name === "" && name.edited}
                helperText={name.name === "" && name.edited ? "Missing name" : ""}
                label="Name"
                variant="outlined"
                className="formTextField"
                style={{width: "48%", margin: "5px"}}
                margin="normal"
                onChange={(e) => setName({name: e.target.value, edited: true})}
                />
                <TextField
                error={email.email === "" && (email.edited || emailError)}
                helperText={email.email === "" && email.edited ? "Missing email" : "" || emailError}
                label="Email"
                variant="outlined"
                className="formTextField"
                style={{width: "48%", margin: "5px"}}
                margin="normal"
                onChange={(e) => setEmail({email: e.target.value, edited: true})}
                />
            </div>
            <div className="fieldBox2">
                <TextField
                label="Subject"
                error={subject.subject === "" && subject.edited}
                helperText={subject.subject === "" && subject.edited ? "Missing subject" : ""}
                variant="outlined"
                className="formTextField"
                style={{width: "97%", margin: "10px"}}
                margin="normal"
                onChange={(e) => setSubject({subject: e.target.value, edited: true})}
                />
                <TextField
                label="Your comment"
                variant="outlined"
                className="formTextField"
                error={comment.comment === "" && comment.edited}
                helperText={comment.comment === "" && comment.edited ? "Missing comment" : ""}
                multiline
                rows={8}
                style={{width: "97%", margin: "10px"}}
                margin="normal"
                inputProps={{
                  style: {
                    padding: 15
                  }
                }}
                onChange={(e) => setComment({comment: e.target.value, edited: true})}
                />
            </div>
          </DialogContent>
          <DialogActions className="dialogActions">
            <Button className="dialogActionButton" disabled={buttonDissable} onClick={() => handleClose()} color="primary">
              Send your message
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
}

export default Popup;
